import { BehaviorSubject } from "@/lib/behavior-subject";

const initialOnline = typeof navigator === "undefined" ? true : navigator.onLine;

export const online$ = new BehaviorSubject<boolean>(initialOnline);

if (typeof window !== "undefined") {
  window.addEventListener("online", () => online$.next(true));
  window.addEventListener("offline", () => online$.next(false));
}
